import type { ScreenModule } from "../../../app/screen-module";
import { AgentSearchPage } from "../AgentPages";

export default {
	id: "end-user.agents",
	path: "/app/agents",
	area: "end-user",
	navGroup: "はたらく",
	label: "Agentを探す",
	roles: ["tenant_member", "tenant_admin", "platform_admin"],
	backing: "ZEROVIA",
	enabled: true,
	component: AgentSearchPage,
} satisfies ScreenModule;
